// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-virtual-assistant",
 "roleDisplay": "AI Virtual Assistant",
 "phrase": "ai virtual assistant",
 "seo": {
  "title": "AI Virtual Assistant: Inbox, Errands, Research | CellCog",
  "description": "An AI virtual assistant that clears your inbox, runs digital errands, compares options and comes back with a recommendation, and keeps your to-do list moving."
 },
 "painSub": "The small tasks never stop: forms, follow-ups, comparisons, bookings, the reply you keep meaning to send. Your AI virtual assistant takes the whole list and comes back with things done, not links.",
 "definition": "An AI virtual assistant is an AI employee that manages your inbox and to-do list, runs digital errands, researches options and handles documents and data entry. On CellCog they are hired in minutes, remember how you like things done, and compare vendors with the agent ranked #1 on DeepResearch Bench (October 2026) before recommending one.",
 "panes": [
  {
   "num": "01 · TO-DO",
   "title": "Works through your list.",
   "sub": "Inbox, errands and follow-ups become a list they clear, one finished item at a time.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--inbox\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">To-dos</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Mia&#x27;s list</b><span>Pulled from email and chat</span></div><div class=\"rf-counts\"><span class=\"rf-count rf-tone-green\"><b>4</b> done</span><span class=\"rf-count rf-tone-blue\"><b>1</b> in progress</span><span class=\"rf-count rf-tone-amber\"><b>2</b> need you</span></div><ul class=\"rf-mails rf-panel\"><li class=\"rf-mail\"><span class=\"rf-av rf-tone-amber\">PH</span><div class=\"rf-mail-m\"><div class=\"rf-mail-top\"><b>Porto hotel</b><span>9:40</span></div><span class=\"rf-mail-s\">Extend your stay by a night?</span><span class=\"rf-mail-p\">Room held until Friday noon. A yes is drafted.</span></div><span class=\"rf-chip rf-tone-amber\">Needs you</span></li><li class=\"rf-mail\"><span class=\"rf-av rf-tone-green\">AD</span><div class=\"rf-mail-m\"><div class=\"rf-mail-top\"><b>Ana Duarte</b><span>9:05</span></div><span class=\"rf-mail-s\">Signed contract</span><span class=\"rf-mail-p\">Countersigned copy sent to Ana and filed in Drive.</span></div><span class=\"rf-chip rf-tone-green\">Done</span></li><li class=\"rf-mail\"><span class=\"rf-av rf-tone-blue\">WV</span><div class=\"rf-mail-m\"><div class=\"rf-mail-top\"><b>Workshop venues</b><span>8:50</span></div><span class=\"rf-mail-s\">Three rooms for Oct 16</span><span class=\"rf-mail-p\">Near the hotel, with daylight and a projector.</span></div><span class=\"rf-chip rf-tone-blue\">In progress</span></li><li class=\"rf-mail\"><span class=\"rf-av rf-tone-amber\">CS</span><div class=\"rf-mail-m\"><div class=\"rf-mail-top\"><b>Co-working space</b><span>8:20</span></div><span class=\"rf-mail-s\">October invoice</span><span class=\"rf-mail-p\">Ready to pay. Payments wait for your yes.</span></div><span class=\"rf-chip rf-tone-amber\">Needs you</span></li></ul></div></div></div>"
  },
  {
   "num": "02 · ANSWER",
   "title": "Comes back with an answer.",
   "sub": "A trip plan, a vendor comparison or a filled form, finished and ready for you.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--doc\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Trip plan</span></div><div class=\"rf-body\"><div class=\"rf-doc\"><div class=\"rf-doc-page\"><b class=\"rf-doc-t\">Porto trip plan</b><span class=\"rf-doc-m\">Oct 14 to 17 · for Mia · updated 5:10 pm</span><b class=\"rf-doc-h\">Tuesday, Oct 14</b><ul><li>Morning flight, lands at 1:40 pm</li><li>Hotel near Ribeira, late check-in confirmed</li></ul><b class=\"rf-doc-h\">Wednesday, Oct 15</b><ul><li>10:00 walk through the workshop venue</li><li>Lunch with Ana, then the evening free</li></ul><b class=\"rf-doc-h\">Thursday, Oct 16</b><ul><li>Client workshop, 9:00 to 4:00</li><li>Car back to the hotel at 4:30</li></ul><b class=\"rf-doc-h\">Friday, Oct 17</b><ul><li>Check out at 11:00, flight at 2:15 pm</li></ul><p>A 90 minute buffer before each flight. The venue is a 12 minute walk from the hotel.</p></div></div></div></div></div>"
  },
  {
   "num": "03 · MEMORY",
   "title": "Remembers how you like it.",
   "sub": "Preferences, addresses and past choices live in your Drive, so you only explain once.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Cobalt Wren</span><i aria-hidden=\"true\">/</i><b>Admin</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">Signed contracts.pdf</span><span class=\"rf-fmeta\">Filed by client</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-xls\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M8 13h2\"/><path d=\"M14 13h2\"/><path d=\"M8 17h2\"/><path d=\"M14 17h2\"/></svg><span class=\"rf-sr\">Spreadsheet</span></span><span class=\"rf-fname\">Receipts log.xlsx</span><span class=\"rf-fmeta\">Every expense this year</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Client onboarding checklist.docx</span><span class=\"rf-fmeta\">9 steps</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Porto workshop</span><span class=\"rf-fmeta\">Added by you</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>Morning flights only, hotels within walking distance, and invoices go out on the 1st.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before they spend or send.",
   "sub": "Purchases, bookings and emails wait for your yes.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Accept the Porto hotel&#x27;s extra night?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><img src=\"https://logos.composio.dev/api/gmail\" alt=\"\" width=\"16\" height=\"16\"><span>Gmail</span><em>To: Casa Ribeira</em></div><b class=\"rf-prev-t\">Re: Extending your stay</b><p class=\"rf-prev-b\">Thank you. Mia would like to keep the room for Friday night too and will check out Saturday at 11:00. Please send the updated confirmation.</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Pay the October co-working invoice</span><span class=\"rf-q-m\">Payment · waits for you</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Book a table for the client dinner</span><span class=\"rf-q-m\">Thu 7:30 · 4 people</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Tells you what got done.",
   "sub": "What they finished today, what is still open and what is waiting on you.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Mia&#x27;s day</b><span>Today, 5:10 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>11</b><span>errands done</span></div><div class=\"rf-stat\"><b>1</b><span>trip planned</span></div><div class=\"rf-stat\"><b>3</b><span>invoices sent</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Planned the Porto trip day by day</li><li>Filed the signed contract and sent a copy</li><li>Sent 3 invoices for September</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Shortlist workshop venues near the hotel</li><li>Book the airport car for Friday</li><li>Renew the domain before it lapses</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Say yes to the extra night in Porto</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Clears your inbox",
   "body": "Sorts the mail, drafts replies in your voice and reminds you before bills, renewals and follow-ups are due."
  },
  {
   "title": "Runs digital errands",
   "body": "Forms, sign-ups, returns and renewals, handled end to end."
  },
  {
   "title": "Researches and recommends",
   "body": "Compares the options and comes back with one recommendation and the reasons."
  },
  {
   "title": "Plans trips",
   "body": "Flights, hotels and a day-by-day plan, with the confirmations filed where you can find them."
  },
  {
   "title": "Answers your phone",
   "body": "Gets their own phone number. Your AI virtual assistant picks up, tells callers they are talking with an AI employee, handles what the assistant can and puts urgent calls through to you."
  },
  {
   "title": "Calls businesses for you",
   "body": "Books, changes or cancels an appointment or reservation with a US business you name, then tells you what was confirmed."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire a virtual assistant. Start with my inbox and the vendor renewals due this month.\""
  },
  {
   "n": "02",
   "title": "Connect what they need.",
   "body": "Add your email, calendar and Drive, and give them a phone number if you want calls answered. You choose what they can reach."
  },
  {
   "n": "03",
   "title": "Hand over the list.",
   "body": "Paste your to-dos. Your AI virtual assistant works through them and asks before anything costs money."
  }
 ],
 "tools": [
  {
   "name": "Gmail",
   "logo": "https://logos.composio.dev/api/gmail"
  },
  {
   "name": "Google Calendar",
   "logo": "https://logos.composio.dev/api/googlecalendar"
  },
  {
   "name": "Google Drive",
   "logo": "https://logos.composio.dev/api/googledrive"
  },
  {
   "name": "Google Docs",
   "logo": "https://logos.composio.dev/api/googledocs"
  },
  {
   "name": "Google Sheets",
   "logo": "https://logos.composio.dev/api/googlesheets"
  },
  {
   "name": "Notion",
   "logo": "https://logos.composio.dev/api/notion"
  },
  {
   "name": "Slack",
   "logo": "https://logos.composio.dev/api/slack"
  },
  {
   "name": "Zoom",
   "logo": "https://logos.composio.dev/api/zoom"
  }
 ],
 "control": {
  "statement": "Nothing is bought or sent without your yes.",
  "sub": "They do the errands.",
  "accent": "You have the final say.",
  "rows": [
   {
    "title": "Asks before spending",
    "body": "Anything that costs money waits for your approval, every time."
   },
   {
    "title": "Sends on your approval",
    "body": "Emails and form submissions wait for your yes unless you approve a kind in advance."
   },
   {
    "title": "Everything visible",
    "body": "Every errand and its result sits on one board you can read any time."
   }
  ]
 },
 "wont": {
  "sub": "They handle the small stuff.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "No physical errands",
    "body": "Picking up a package still needs a person; anything digital is fair game."
   },
   {
    "title": "No sends without your yes",
    "body": "Emails and form submissions wait for your approval by default."
   },
   {
    "title": "No purchases on their own",
    "body": "They find the best option; you approve anything that costs money."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to handle the small stuff",
  "cols": [
   "Doing it yourself",
   "A chatbot",
   "AI Virtual Assistant"
  ],
  "rows": [
   {
    "label": "Remembers your preferences",
    "cells": [
     "Yes",
     "Forgets between chats",
     "Yes, in their memory"
    ]
   },
   {
    "label": "Starts work without being asked",
    "cells": [
     "n/a",
     "No",
     "On a schedule"
    ]
   },
   {
    "label": "Sends emails and fills forms",
    "cells": [
     "You",
     "No",
     "Yes, after your approval"
    ]
   },
   {
    "label": "Comes back with a recommendation",
    "cells": [
     "You",
     "Suggests options",
     "A finished answer"
    ]
   },
   {
    "label": "Answers and makes phone calls",
    "cells": [
     "You",
     "No",
     "Yes, on their own number"
    ]
   },
   {
    "label": "Asks before spending",
    "cells": [
     "n/a",
     "n/a",
     "Always"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Go through my inbox from the last week. Draft replies for everything that needs one, flag the three things that actually need my attention, and archive the noise.",
   "deliverable": "a triaged inbox with reply drafts"
  },
  {
   "q": "Plan a 3-day trip to Austin for the conference: flights from JFK, a hotel near the venue, and a day-by-day itinerary.",
   "deliverable": "a complete travel plan"
  },
  {
   "q": "Turn these meeting notes into a clean summary, a decision log, and a follow-up email to the team.",
   "deliverable": "meeting notes turned into action items"
  },
  {
   "q": "Build a tracker for our vendor contracts: renewal dates, costs, and owners, and remind me 30 days before each renewal.",
   "deliverable": "a contract tracker with automatic reminders"
  },
  {
   "q": "Find the best project management tool for a team of six on a tight budget. Compare the top options and recommend one.",
   "deliverable": "a vendor comparison with a recommendation"
  }
 ],
 "faq": [
  {
   "q": "What is an AI virtual assistant?",
   "a": "An AI virtual assistant is an AI employee that manages your inbox and to-do list, runs digital errands, researches options and handles documents and data entry."
  },
  {
   "q": "What can an AI virtual assistant do?",
   "a": "Anything digital on your list: sort and answer email, fill out forms, compare products or vendors, plan a trip, keep trackers current and remind you before deadlines."
  },
  {
   "q": "How is a virtual AI assistant different from a chatbot?",
   "a": "A chatbot answers when you ask and forgets you after. This one has their own inbox and task board, remembers your preferences and starts work on a schedule without being asked."
  },
  {
   "q": "Do they learn how I like things done?",
   "a": "Yes. They keep what you tell them and what you correct in their memory, so the tenth request needs fewer notes than the first."
  },
  {
   "q": "Can I trust virtual assistant AI with my inbox?",
   "a": "You choose what to connect and can disconnect anytime. Emails wait for your approval by default, and everything your AI virtual assistant does is visible on their task board."
  },
  {
   "q": "Can they join my video calls?",
   "a": "Yes. Invite them to Google Meet, Zoom or Microsoft Teams and they join under their own name, camera off, take the notes and follow up afterward."
  },
  {
   "q": "Can an AI virtual assistant handle customer service?",
   "a": "Yes, for the everyday questions. They answer customer email in your voice, can answer calls on their own phone number and hand anything they cannot resolve to you. For a full support inbox, hire an AI customer support agent."
  },
  {
   "q": "Is an AI virtual assistant a good fit for a small business?",
   "a": "Yes. Small businesses use one AI-powered virtual assistant for the work that piles up between customers: email, scheduling, research and paperwork. Your AI virtual assistant learns your preferences once and keeps them."
  },
  {
   "q": "Can I try an AI virtual assistant for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI virtual assistant and try a first task."
  },
  {
   "q": "What does an AI virtual assistant cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire your AI Virtual Assistant in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI Virtual Assistant to work today",
  "body": "Hand them your inbox and your calendar and get back a triaged week, drafted replies, and a schedule that finally makes sense."
 },
 "audience": {
  "title": "Who hires an AI virtual assistant",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "Getting their week back",
    "body": "The inbox, the scheduling and the digital errands handed off, and the hours spent on admin back on the work only they can do."
   },
   {
    "badge": "Small businesses",
    "title": "One assistant for the whole team",
    "body": "A shared virtual AI assistant handles scheduling, research, documents and follow-ups for everyone on the team."
   },
   {
    "badge": "Mid-size companies",
    "title": "An assistant for each team",
    "body": "Hire one per team or per leader. Each keeps their own preferences, and the people you give access can see the assistant's work."
   },
   {
    "badge": "Agencies",
    "title": "An assistant on every account",
    "body": "Trackers kept current, reports on schedule and client inboxes answered, one account at a time."
   },
   {
    "badge": "Busy professionals",
    "title": "Admin off the evenings",
    "body": "Consultants, coaches and advisors hand off the scheduling, forms and follow-ups that pile up between client work."
   },
   {
    "badge": "Customer service",
    "title": "Everyday customer questions answered",
    "body": "Your AI virtual assistant answers customer email in your voice and passes anything they cannot resolve to you."
   }
  ]
 }
};

export default content;
